import { combineReducers } from 'redux';
import auth from './auth';
import maps from './maps';
import lists from './lists';
import general from './general';
import ticket from './ticket';
import timeClockPermission from './timeClockPermission';
import { connectRouter } from 'connected-react-router';

//import user from './user';

const allReducers = (history) =>
	combineReducers({
		router: connectRouter(history),
		auth,
		general,
		lists,
		maps,
		ticket,
		timeClockPermission,
	});
export default allReducers;
